import * as React from 'react';
import { StatusBadge } from '@leagueplatform/genesis-core';
import type { EntityDetail } from '@web-config-app/core';
import { getEntityStatusBadgeProps } from '@web-config-app/core';
import { useIntl } from '@leagueplatform/locales';
import { LinkableCell } from '../table-pieces.component';

export type StatusCellProps = {
  item: EntityDetail;
  linkTo?: string;
};

export const StatusCell: React.FC<StatusCellProps> = ({ item, linkTo }) => {
  const { formatMessage } = useIntl();
  const statusBadgeProps = getEntityStatusBadgeProps(
    item.attributes.entityMetadata?.status,
  );
  return (
    <LinkableCell linkTo={linkTo}>
      <StatusBadge
        showLight={false}
        status={statusBadgeProps.genesisStatus}
        label={formatMessage({ id: statusBadgeProps.labelKey })}
      />
    </LinkableCell>
  );
};
